import { useEffect, useRef, useState } from "react";

import aboutPoster from "@/assets/images/user/aboutPoster.jpg";
// import programArt from "@/assets/images/user/programArt.svg";
// import programArtPattern from "@/assets/images/user/programArtPattern.png";
// import programFesta from "@/assets/images/user/programFesta.svg";
// import programFestaPattern from "@/assets/images/user/programFestaPattern.png";
// import programFocus from "@/assets/images/user/programFocus.svg";
// import programFocusPattern from "@/assets/images/user/programFocusPattern.png";
// import programLabelDeco from "@/assets/images/user/programLabelDeco.svg";
// import programPlay from "@/assets/images/user/programPlay.svg";
// import programPlayPattern from "@/assets/images/user/programPlayPattern.png";
// import programStage from "@/assets/images/user/programStage.svg";
// import programStagePattern from "@/assets/images/user/programStagePattern.png";
import ComingSoon from "@/components/user/common/ComingSoon";
// import ProgramAccordion from "@/components/user/common/ProgramAccordion";
import SubTitle from "@/components/user/common/SubTitle";
import TitleBox from "@/components/user/common/TitleBox";

// const programList = [
//     {
//         title: "무대 프로그램",
//         background: "bg-[linear-gradient(90deg,#EF4C3C_0%,#E84731_100%)]",
//         pattern: programStagePattern,
//         patternStyle: { backgroundSize: "213.6px 417.6px", opacity: 0.1 },
//         img: programStage,
//         contents: <ComingSoon />,
//     },
//     {
//         title: "체험 프로그램",
//         background: "bg-[linear-gradient(90deg,#00A8A0_0%,#00B8BB_100%)]",
//         pattern: programPlayPattern,
//         patternStyle: { backgroundSize: "213.6px 417.6px", opacity: 0.1 },
//         img: programPlay,
//         contents: <ComingSoon />,
//     },
//     {
//         title: "전시 프로그램",
//         background: "bg-[linear-gradient(90deg,#CF3E94_0%,#CF3189_100%)]",
//         pattern: programArtPattern,
//         patternStyle: { backgroundSize: "213.6px 417.6px", opacity: 0.14 },
//         img: programArt,
//         contents: <ComingSoon />,
//     },
//     {
//         title: "GXG 컨퍼런스",
//         background: "bg-[linear-gradient(90deg,#F6921E_0%,#F7CB46_100%)]",
//         pattern: programFocusPattern,
//         patternStyle: { backgroundSize: "320px 640px", opacity: 0.9 },
//         img: programFocus,
//         contents: <ComingSoon />,
//     },
//     {
//         title: "GXG 콜라보레이션",
//         background: "bg-[linear-gradient(90deg,#0376B9_0%,#026EB5_100%)]",
//         pattern: programFestaPattern,
//         patternStyle: { backgroundSize: "cover", backgroundRepeat: "no-repeat", opacity: 0.1 },
//         img: programFesta,
//         contents: <ComingSoon />,
//     },
// ];

const infoList = [
    {
        label: "행사명",
        value: (
            <>
                GXG 2026 <br className="md:hidden" />
                <span className="text-[14px] md:text-[22px]">(Game culture X Generation 2026)</span>
            </>
        ),
        valueClass: "leading-[1.5]",
    },
    { label: <>일&nbsp;&nbsp;&nbsp;&nbsp;정</>, value: "9월 11일(금)~12일(토), 2일 간" },
    { label: <>장&nbsp;&nbsp;&nbsp;&nbsp;소</>, value: "경기도 성남시 판교역 일대" },
    { label: <>주&nbsp;&nbsp;&nbsp;&nbsp;최</>, value: "성남시" },
    { label: <>주&nbsp;&nbsp;&nbsp;&nbsp;관</>, value: "성남산업진흥원, 게임문화재단" },
    {
        label: <>후&nbsp;&nbsp;&nbsp;&nbsp;원</>,
        value: "문화체육관광부, 한국콘텐츠진흥원, 게임물관리위원회, 경기도, 경기관광공사, 넥슨코리아, 엔씨",
        // isStart: true,
        isStart: false,
        valueClass: "text-[15px]",
    },
];

export default function About() {
    const sect2Ref = useRef<HTMLDivElement>(null);
    const [sect2On, setSect2On] = useState(false);

    //스크롤시 section on
    const scrollSectOn = () => {
        const scroll = window.scrollY;
        const sections: {
            ref: React.RefObject<HTMLDivElement>;
            onSet: React.Dispatch<React.SetStateAction<boolean>>;
        }[] = [{ ref: sect2Ref, onSet: setSect2On }];

        sections.forEach(({ ref, onSet }) => {
            if (ref.current) {
                const offsetTop = ref.current.offsetTop;
                if (scroll >= offsetTop - 100) {
                    onSet(true);
                }
            }
        });
    };

    useEffect(() => {
        window.addEventListener("scroll", scrollSectOn);

        return () => {
            window.removeEventListener("scroll", scrollSectOn);
        };
    }, []);

    return (
        <div className="px-[20px] xl:px-0">
            <section>
                <div className="mx-auto flex w-full max-w-[1400px] flex-col gap-[30px] p-[20px_0_40px] text-center font-['GongGothicMedium'] text-[18px] md:gap-[60px] md:p-[80px_0_120px] md:text-[28px] [&>p>span]:text-primary">
                    <p className="text-[28px] md:text-[48px]">
                        Welcome to <span>GXG</span>
                    </p>
                    <p>
                        전 세대가 모두 함께 <br className="md:hidden" />
                        게임 문화를 즐길 수 있는 공간!
                    </p>
                    <p>
                        GXG는 단순히 완성된 게임을 <br className="md:hidden" />
                        체험하는 것을 넘어, <br />
                        다양한 게임의 문화적 요소에 초점을 맞춘 <span>복합문화축제</span> 입니다.
                    </p>
                    <p>
                        음악, 영상, 아트, 스토리 등 <br className="md:hidden" />
                        게임이 가진 <br />
                        다채로운 요소들이 어우러져
                        <br />
                        가장 색다른 게임 축제로 기억에 남을 <br className="md:hidden" />
                        <span>GXG</span>에 여러분을 초대합니다!
                    </p>
                </div>
            </section>
            <section className="mx-auto w-full max-w-[1400px] pb-[120px] md:pb-[160px]" ref={sect2Ref}>
                <TitleBox title="ABOUT" text="GXG 2026 소개" />
                <div className="pt-[40px] md:pt-[60px] xl:flex xl:gap-[48px]">
                    <div className={`xl:opacity-0${sect2On ? " xl:animate-slide-in-from-bottom-30" : ""}`}>
                        <img src={aboutPoster} alt="GXG 2025" />
                    </div>
                    <div
                        className={`w-full pt-[40px] md:pt-[60px] xl:flex-1 xl:pt-0 xl:opacity-0${sect2On ? " xl:animate-slide-in-from-right" : ""}`}
                    >
                        <ul className="flex flex-col gap-[12px] md:gap-[16px] xl:h-full xl:justify-between">
                            {infoList.map((item, idx) => (
                                <li
                                    key={idx}
                                    className={`flex ${item.isStart ? "items-start" : "items-center"} gap-[12px] md:gap-[16px]`}
                                >
                                    <p className="w-full max-w-[70px] rounded-[8px] border border-transparent py-[8px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[28px] text-[#000] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] [background-clip:padding-box,border-box] [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] md:max-w-[140px] md:py-[18px] md:text-[22px]">
                                        {item.label}
                                    </p>
                                    <p
                                        className={`flex-1 font-['GongGothicLight'] font-medium text-black md:text-[24px] ${item.valueClass || "text-[16px] leading-[1.8]"}`}
                                    >
                                        {item.value}
                                    </p>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <SubTitle title="프로그램" className="p-[40px_0_20px] md:p-[60px_0_40px]" />
                <ComingSoon />
                {/* <ProgramAccordion
                    list={programList}
                    contentClassName="p-0 md:p-0"
                    className="gap-[16px] md:gap-[24px]"
                    triggerClassName="md:[&>p]:text-[32px]"
                    deco={programLabelDeco}
                    disableToggle
                /> */}
            </section>
        </div>
    );
}
